// extracted by mini-css-extract-plugin
export var cardHeader = "_gk-0";
export var reorderHandle = "_gk-3";
export var titleArea = "_gk-1";
export var titleAreaWithHandle = "_gk-2";